module.exports = __webpack_public_path__ + "img/bonus.1a827ad0.jpg";